module.exports = __webpack_public_path__ + "images/064145147ae9ba941597a1ab2245a3a0-illu_windowDoor.svg";